import React from 'react';
import './PricingCard.css';

const PricingCard = ({
  title,
  subtitle,
  features,
  borderHighlight,
  contactSales,
  ctaLabel,
  onCtaClick,
  onContactSalesClick,
}) => {
  return (
    <div className={`pricing-card ${borderHighlight ? 'highlighted' : ''}`}>
      <div className="pricing-header">
        <h2 className="pricing-title">{title}</h2>
        <div className="pricing-subtitle">{subtitle}</div>
      </div>

      <div className="pricing-divider"></div>

      <div className="pricing-features">
        <ul>
          {features.map((item, idx) => (
            <li key={`feature-${idx}`}>
              <svg className="check-icon" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
              {item}
            </li>
          ))}
        </ul>
      </div>

      <div className="pricing-cta">
        {contactSales ? (
          <button
            className="pricing-button contact-sales-button"
            onClick={onContactSalesClick}
          >
            Contact Sales
          </button>
        ) : (
          <button
            className="pricing-button"
            onClick={onCtaClick}
          >
            {ctaLabel || 'Start a Pilot'}
          </button>
        )}
      </div>
    </div>
  );
};

export default PricingCard;
